<script setup lang="ts">
import { defaultRelations } from "@/constants/storyblok";

const { story, blok } = await useStoryblokContent({
  resolve_relations: defaultRelations,
});
</script>

<template>
  <div class="page-container">
    <StoryblokComponent v-bind="{ blok, story }" />
  </div>
</template>
